<template>
    <div class="min-h-[65vh]" v-if="!loading">
        <div class="container mx-auto mt-8 content" v-html="$translate(get.content)"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../api';

export default {
    data: () => ({
        loading: true
    }),
    mounted() {
        this.loading = true;
        api.get(`/api/v1/slugs/performance`).then((response) => {
            this.$store.commit('contentpage/set', response.data);
            this.loading = false;
        });
    },
    computed: {
        ...mapGetters('contentpage', ['get'])
    }
};
</script>

<style>
@media (max-width: 768px) {
    h1,
    span[style='font-size: 30px;'] {
        font-size: larger !important;
    }
}
</style>
